
import XButton from 'vux/src/components/x-button/index.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'

import {fetch,promptMessage} from '../../api/dataHandling';
import {urlConfig} from '@/api/urlConfig';
import hbImg from '../../project/IntegralProject/images/hb.png'
import contentImg1 from '../../project/IntegralProject/images/bgt1.png'
import contentImg from '../../project/IntegralProject/images/bgt.png'
import {getken} from '@/api/getToken';
import $ from 'jquery';

export default {

data(){
return {
integration:'',
hbshow:false,
noEffective:false,
hbImg:hbImg,
contentImg1:contentImg1,
}
},
components: {
FlexboxItem,XButton, Flexbox
},
methods:{
getData(){
this.integration = this.$route.query.jifen;
this.integralTranflow = this.$route.query.integralTranflow;
this.messageId = this.$route.query.messageId;
var  _this = this;
fetch('get',urlConfig.jifenRedPacket +'?jifen='+this.integration+'&integralTranflow=' +this.integralTranflow+'&messageId='+this.messageId).then(function(response){
var statusNum = response.status;
if(statusNum == 1){
_this.hbshow = true;
_this.noEffective = false;
}else if(statusNum == 2){
_this.hbshow = false;
_this.noEffective = false;
$('.content').css({'background':'url('+ contentImg+')','background-repeat':'no-repeat','background-size':'100% 100%'});
$('.group').animate({'bottom':'20%'},600)
}else {
_this.noEffective = true;
_this.hbshow = false;
$('.content').css({'background':'url('+ contentImg+')','background-repeat':'no-repeat','background-size':'100% 100%'});
$('.group').animate({'bottom':'20%'},600)
}

}).catch(function(error){

})
},//获取数据
hbClick(){
$('.content').css({'background':'url('+ contentImg+')','background-repeat':'no-repeat','background-size':'100% 100%'});
$('.hb').animate({'width':'10%','margin':'0','top':0,'left':0,'opacity':0},600);
$('.hb').addClass('active');
$('.group').animate({'bottom':'20%'},400)
}
},
mounted(){
getken(this.getData);
}
}



// WEBPACK FOOTER //
// ./src/project/IntegralProject/IntegralRedPacket.vue